const filters = {
  "strength": {
    "min": 0,
    "max": 20,
    "lowDescriptor": "0%",
    "highDescriptor": "20%",
    "displayValueInSlider": true,
    "step": 1
  },
  "bitterness": {
    "min": 0,
    "max": 5,
    "lowDescriptor": "",
    "highDescriptor": "Bitter",
    "displayValueInSlider": false,
    "step": 1
  },
  "colour": {
    "min": 0,
    "max": 100,
    "lowDescriptor": "Pale",
    "highDescriptor": "Dark",
    "displayValueInSlider": false,
    "step": 10
  }
}

export default filters;